/** 首页经营看板卡片预览区固定高度（独立于制作区与统计页经营看板） */
export const HOME_DASHBOARD_CHART_PREVIEW_HEIGHT = '20rem';

/** @deprecated 使用 HOME_DASHBOARD_CHART_PREVIEW_HEIGHT */
export const HOME_DASHBOARD_LINE_CHART_HEIGHT = HOME_DASHBOARD_CHART_PREVIEW_HEIGHT;

export const resolveHomeDashboardChartCardPreviewHeight = () => HOME_DASHBOARD_CHART_PREVIEW_HEIGHT;

/** 锁定首页经营看板预览槽高度，骨架屏与加载完成后保持一致 */
export const buildHomeDashboardChartPreviewSlotStyle = (height = HOME_DASHBOARD_CHART_PREVIEW_HEIGHT) => ({
	'--home-dashboard-chart-preview-height': height,
	'--statistics-saved-chart-preview-height': height,
	flex: `0 0 ${height}`,
	height,
	minHeight: height,
	maxHeight: height,
	overflow: 'hidden',
	boxSizing: 'border-box',
});

export default HOME_DASHBOARD_CHART_PREVIEW_HEIGHT;
